module.exports = __webpack_public_path__ + "img/Logo_stay.a06025dc.png";